<div
  class="tw:px-(--p-dialog-header-padding) tw:pb-(--p-dialog-header-padding) tw:[--p-button-primary-background:var(--p-primary-hover-color)] tw:[--p-button-primary-border-color:var(--p-primary-hover-color)] tw:[--p-red-600:var(--p-red-700)]"
>
  <change-password-form (submitted)="passwordChanged($event)" />
</div>
